import React from 'react'

import { Paper, Box } from '@material-ui/core'

const SignupStepsContainer = ({ children }) => (
  <Paper variant="outlined">
    <Box p={3}>{children}</Box>
  </Paper>
)

export default SignupStepsContainer
